class SocialMediaBanner extends HTMLElement {
  constructor() {
    super();
    this.activeTab = 'insta';
  }

  connectedCallback() {
    this.setupTabs();
  }

  setupTabs() {
    // Find the parent container since tabs are outside this custom element
    const container = this.closest('.social-media-banner-container') || this.closest('.social-media-banner-wrapper');
    if (!container) return;

    const tabs = container.querySelectorAll('.social-media-banner-tab');
    const sliders = this.querySelectorAll('.social-media-banner-slider');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const platform = tab.getAttribute('data-tab');
        
        // Update active tab
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        
        // Update active slider
        sliders.forEach(slider => {
          slider.classList.remove('active');
        });
        
        const activeSlider = this.querySelector(`.social-media-banner-slider[data-platform="${platform}"]`);
        if (activeSlider) {
          activeSlider.classList.add('active');
          
          // Update Swiper instance if it exists
          const collectionSlider = activeSlider.querySelector('collection-slider');
          if (collectionSlider) {
            const swiperEl = collectionSlider.querySelector('.swiper-collection-slider');
            if (swiperEl && swiperEl.swiper) {
              setTimeout(() => {
                swiperEl.swiper.update();
              }, 100);
            }
          }
        }
        
        this.activeTab = platform;
      });
    });
  }
}

if (!customElements.get('social-media-banner')) {
  customElements.define('social-media-banner', SocialMediaBanner);
}

